export default [
  {
    name: 'login',
    path: '/login',
    component: () => import(/* webpackChunkName: "event" */ './pages/Login.vue'),
    meta: {
      roles: []
    }
  },
  {
    name: 'sso',
    path: '/sso',
    component: () => import(/* webpackChunkName: "sso" */ './pages/SsoAuth.vue'),
    meta: {
      roles: []
    }
  }
]
